// @flow
import {
  API_GET,
  API_GET_ARRAY,
  API_CREATE,
  API_UPDATE,
  API_DELETE
} from '@redux/components/ApiRequest/constants';

import type {
  CreateAction,
  UpdateAction,
  DeleteAction,
  GetAction,
  Action,
  ApiRequestOptions
} from '@redux/components/ApiRequest/types';

export const getResource = (
  url: string,
  successAction: (data: any, included: any) => Action,
  errorAction: (error: Error) => Action
): GetAction => ({
  type: API_GET,
  url,
  successAction,
  errorAction
});

export const getArrayResource = (
  url: string,
  successAction: (data: any, included: any, headers: any, meta?: any) => Action,
  errorAction: (error: Error) => Action,
  options?: ApiRequestOptions
): GetAction => ({
  type: API_GET_ARRAY,
  url,
  successAction,
  errorAction,
  options
});

export const createResource = (
  url: string,
  body: {},
  successAction: () => Action,
  errorAction: (error: Error) => Action
): CreateAction => ({
  type: API_CREATE,
  url,
  body,
  successAction,
  errorAction
});

export const updateResource = (
  id: string,
  url: string,
  body: {},
  successAction: (id: string) => Action,
  errorAction: (id: string, error: Error) => Action
): UpdateAction => ({
  type: API_UPDATE,
  id,
  url,
  body,
  successAction,
  errorAction
});

export const deleteResource = (
  id: string,
  url: string,
  successAction: (id: string) => Action,
  errorAction?: (id: string, error: Error) => Action
): DeleteAction => ({
  type: API_DELETE,
  id,
  url,
  successAction,
  errorAction
});
